// Base configuration for all environments
const config = {
  development: {
    API_BASE_URL: 'http://localhost:3222',
    TRACKING_ENABLED: false,
    PLAUSIBLE_DOMAIN: 'payetachargementale.com',
  },
  production: {
    API_BASE_URL: 'https://payetachargementale.com', // Empty string for relative paths in production
    TRACKING_ENABLED: true,
    PLAUSIBLE_DOMAIN: 'payetachargementale.com',
  },
  test: {
    API_BASE_URL: 'http://192.168.68.52:3222',
    TRACKING_ENABLED: false,
    PLAUSIBLE_DOMAIN: 'payetachargementale.com',
  }
};

// Get current environment, fallback to 'development' if not set
const env = process.env.NODE_ENV || 'development';

// Export the configuration for the current environment
export const API_BASE_URL = config[env].API_BASE_URL;

export const COOKIE_DOMAIN = process.env.REACT_APP_COOKIE_DOMAIN || '.payetachargementale.com';
export const COOKIE_SECURE = process.env.NODE_ENV === 'production'; // true en production, false en développement
export const COOKIE_MAX_AGE = 7 * 24 * 60 * 60; // 7 jours en secondes

export const TRACKING_ENABLED = config[env].TRACKING_ENABLED;
export const PLAUSIBLE_DOMAIN = config[env].PLAUSIBLE_DOMAIN;

// You can add more configuration exports here if needed
const currentConfig = {
  API_BASE_URL,
  TRACKING_ENABLED,
  PLAUSIBLE_DOMAIN
};

export default currentConfig;
